import { DeviceType } from "@virtualprogaming/js-public-sdk";
import { partial } from "lodash-es";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { NOTIFICATIONS_SETTINGS } from "~/constants";
import { useFcmUnsubscribe, useUser } from "~/queries";
import { useLogout } from "~/queries/auth";
import { useCurrentUser } from "~/utils";

import { Chat, PremiumModal } from "../components";
import { useChatSettings } from "../context";
import { PremiumModalContext } from "../context/premiumModalContext";
import Footer from "./footer";
import Header from "./header";

type LayoutProps = {
  children: JSX.Element | JSX.Element[];
};

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const showHeader = location.pathname === "/welcome";
  const { open: premiumModalOpened } = useContext(PremiumModalContext);
  const currentUser = useCurrentUser();
  const { data } = useUser(currentUser?.username);
  const logout = useLogout();
  const { mutateAsync: fcmUnubscribe } = useFcmUnsubscribe();

  const [elapsedTime, setElapsedTime] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const { setIsChatOpen } = useChatSettings();

  useEffect(() => {
    if (data?.banned_until) {
      fcmUnubscribe(DeviceType.Web);
      logout();
      localStorage.removeItem(NOTIFICATIONS_SETTINGS);
    }
  }, [data?.banned_until, fcmUnubscribe, logout]);

  useEffect(() => {
    if (startTime === 0) {
      setStartTime(window.performance.now());
    }

    const interval = setInterval(() => {
      const currentTime = window.performance.now();
      const elapsed = Math.floor((currentTime - startTime) / 1000);
      setElapsedTime(elapsed);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  const resetElapsedTime = () => {
    setStartTime(window.performance.now());
    setElapsedTime(0);
  };

  return (
    <>
      {!showHeader && <Header onOpenChat={partial(setIsChatOpen, true)} />}
      {children}
      {premiumModalOpened && <PremiumModal />}
      {!showHeader && <Footer />}

      <Chat elapsedTime={elapsedTime} onFinish={resetElapsedTime} />
    </>
  );
};

export default Layout;
